module.exports = __webpack_public_path__ + "static/img/12.902382d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/12.png
// module id = J+69
// module chunks = 0